import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "invalid-feedback" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MoneyInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "" },
    placeholder: { default: "" },
    errorMsg: { default: "Por favor, preencha este campo corretamente" },
    inputStyle: { default: null },
    required: { type: Boolean, default: false }
  },
  setup(__props: any) {



const config = {
  prefix: "R$ ",
  thousands: "",
  decimal: ",",
  precision: 2,
  disableNegative: true,
  minimumNumberOfCharacters: 1,
  modelModifiers: {
    number: true,
  },
};

return (_ctx: any,_cache: any) => {
  const _directive_money3 = _resolveDirective("money3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.model.$error }]),
      type: "text",
      placeholder: _ctx.placeholder,
      style: _normalizeStyle(_ctx.inputStyle)
    }, null, 14, _hoisted_5), [
      [
        _vModelText,
        _ctx.model.$model,
        void 0,
        { lazy: true }
      ],
      [_directive_money3, config]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("small", null, _toDisplayString(_ctx.errorMsg), 1)
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})